import { __ } from '@wordpress/i18n';

export const validateUrl = ( value ) => {
	if ( ! value ) {
		return false;
	}

	if ( value.length < 5 || ! /^https?:\/\/.+/.test( value ) ) {
		return false;
	}

	return true;
};

export const validateClientSecret = ( value ) => {
	if ( ! value ) {
		return false;
	}

	if ( value.length < 12 ) {
		return false;
	}

	return true;
};
